/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardFunnelDTO } from './dashboard-funnel-dto';


export interface DashboardPraticheDTO { 
    /**
     * Conteggio pratiche per stato (tutte le chiavi RichiestaPraticaStatus, zero-fill)
     */
    counts?: { [key: string]: number; };
    total?: number;
    funnel?: DashboardFunnelDTO;
}

